import React from 'react';
import { Sun, Moon, Bell, User, Shield } from 'lucide-react';
import { useApp } from '@/context/AppContext';

const AppHeader = ({ title, adminMode }) => {
  const { theme, toggleTheme } = useApp();

  return (
    <header className="app-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h1 className="page-title">{title}</h1>
        {adminMode && (
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '4px 10px', 
            background: 'linear-gradient(135deg, rgba(245, 87, 108, 0.15) 0%, rgba(240, 147, 251, 0.15) 100%)',
            border: '1px solid rgba(245, 87, 108, 0.3)',
            borderRadius: 6, fontSize: '0.6875rem', fontWeight: 700, color: '#f5576c'
          }}>
            <Shield size={12} /> ADMIN
          </span>
        )}
      </div>
      <div className="header-actions">
        <button className="header-btn" onClick={toggleTheme}>
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button className="header-btn"><Bell size={18} /></button>
        <button className="header-btn"><User size={18} /></button>
      </div>
    </header>
  );
};

export default AppHeader;
